import { Chip, Tooltip } from '@mui/material';
import React from 'react';

import { IntegrationStatus } from '../../types';

interface CalDavStatusIndicatorProps {
  status: IntegrationStatus;
  message?: string | null;
}

const statusConfig: Record<
  IntegrationStatus,
  { label: string; color: 'success' | 'error' | 'default' }
> = {
  active: { label: 'Активна', color: 'success' },
  inactive: { label: 'Неактивна', color: 'error' },
  not_configured: { label: 'Не настроена', color: 'default' },
};

export const CalDavStatusIndicator: React.FC<CalDavStatusIndicatorProps> = ({
  status,
  message,
}) => {
  const config = statusConfig[status];

  const chip = <Chip label={config.label} color={config.color} size="small" />;

  if (message) {
    return <Tooltip title={message}>{chip}</Tooltip>;
  }

  return chip;
};
